"use client"

import { useState, Suspense } from "react"
import BookingSystem from "@/components/booking/booking-system"
import BookingLookup from "@/components/booking/booking-lookup"
import PageHero from "@/components/page-hero"
import { pageHeroData } from "@/data/page-hero-data"
import { Phone, Mail, HelpCircle } from "lucide-react"
import Link from "next/link"
import { COMPANY } from "@/lib/site-config"

export default function BookingPage() {
  const heroData = pageHeroData.buchen
  const [isSelectStep, setIsSelectStep] = useState(true)

  return (
    <>
      <PageHero title={heroData.title} description={heroData.description} backgroundImage={heroData.backgroundImage} />

      <div className="py-16">
        <div className="container-custom">
          <Suspense fallback={<div className="flex items-center justify-center py-24"><div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-[var(--main-color)]" /></div>}>
            <BookingSystem onStepChange={(step) => setIsSelectStep(step === "SELECT")} />
          </Suspense>

          {/* Buchungsnummer nachschlagen — nur auf der ersten Seite */}
          {isSelectStep && (
            <div className="mt-16">
              <BookingLookup />
            </div>
          )}

          {/* Kontakt-Hinweis — nur auf der ersten Seite */}
          {isSelectStep && (
            <div className="mt-12 rounded-2xl border border-gray-200 bg-gray-50 p-8 text-center">
              <HelpCircle className="mx-auto mb-3 h-8 w-8 text-[var(--main-color)]" />
              <h3 className="text-lg font-bold text-gray-900 mb-2">Nicht das dabei was du suchst?</h3>
              <p className="text-gray-600 mb-4 max-w-md mx-auto">
                Kein Problem! Kontaktiere uns und wir helfen dir gerne bei deiner Buchung weiter.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href={COMPANY.phoneHref}
                  className="inline-flex items-center gap-2 rounded-lg bg-[var(--main-color)] px-5 py-2.5 text-sm font-medium text-white hover:opacity-90 transition"
                >
                  <Phone className="h-4 w-4" />
                  {COMPANY.phone}
                </a>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-5 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-100 transition"
                >
                  <Mail className="h-4 w-4" />
                  {COMPANY.email}
                </a>
                <Link
                  href="/kontakt"
                  className="text-sm font-medium text-[var(--main-color)] hover:underline"
                >
                  Zum Kontaktformular →
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
